import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { reportsApi } from '@/api/reports';
import { toast } from 'sonner';
import { Sections } from '@/components/wizard/types';

export function useSectionDefaults(sectionId: string, options: { enabled?: boolean } = {}) {
    const queryClient = useQueryClient();
    const { enabled = true } = options;

    const { data: defaults, isLoading: isLoadingDefaults } = useQuery({
        queryKey: ['report-defaults'],
        queryFn: reportsApi.getDefaults,
        staleTime: 5 * 60 * 1000,
        enabled,
    });

    const defaultSection = defaults?.find((d) => d.section_type === sectionId);
    const defaultContent = defaultSection?.content || '';

    const updateDefaultMutation = useMutation({
        mutationFn: async (content: string) => {
            if (!content) return;
            await reportsApi.updateDefault(sectionId as Sections, content);
        },
        onSuccess: () => {
            toast.success('Conteúdo padrão atualizado com sucesso');
            queryClient.invalidateQueries({ queryKey: ['report-defaults'] });
        },
        onError: () => {
            toast.error('Erro ao atualizar conteúdo padrão');
        },
    });

    return {
        defaultContent,
        isLoadingDefaults,
        updateDefault: updateDefaultMutation.mutate,
        isUpdating: updateDefaultMutation.isPending,
    };
}
